/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataMessageResponse_Goals_ } from "../models/DataMessageResponse_Goals_";
import type { DataResponse_Goals_ } from "../models/DataResponse_Goals_";
import type { Goals } from "../models/Goals";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class GoalsService {
  /**
   * Update Goals
   * Updates the goals for a user.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_Goals_ Successful Response
   * @throws ApiError
   */
  public static updateGoalsApiV1GoalsPut(
    xUserId: string,
    requestBody: Goals,
  ): CancelablePromise<DataMessageResponse_Goals_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/goals",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Goals
   * Returns the goals for a user.
   * @param xUserId
   * @returns DataResponse_Goals_ Successful Response
   * @throws ApiError
   */
  public static getGoalsApiV1GoalsGet(xUserId: string): CancelablePromise<DataResponse_Goals_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/goals",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Goals By Admin
   * Used by an admin to get information about a user's goals.
   * @param userId
   * @returns DataResponse_Goals_ Successful Response
   * @throws ApiError
   */
  public static getGoalsByAdminApiV1GoalsUserIdGet(
    userId: string,
  ): CancelablePromise<DataResponse_Goals_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/goals/{user_id}",
      path: {
        user_id: userId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
